import moment from 'moment';
import { ExcelCellValue } from '@common/xlsxExport/types';

const wrap = (array: ExcelCellValue[]) => array.map(row => [row]);

const createTimestamp = () => moment().format('M/D/YYYY/H:mm:ss A');

type MetadataBuilderParams = {
    appName?: string,
    sheetTitle?: string,
    sheetDescription?: string,
    additionalMetadataRows?: ExcelCellValue[],
    periodName?: string,
    addTimestamp?: boolean,
}

const metadataBuilder = (params: MetadataBuilderParams) => {
  const {
    appName,
    sheetTitle,
    sheetDescription,
    additionalMetadataRows,
    periodName,
    addTimestamp,
  } = params;

  const timestamp = addTimestamp
    ? [[createTimestamp()]]
    : [];

  const periodNameRow = periodName ? [[periodName]] : [];

  const grid = [
    ...timestamp,
    [appName],
    [sheetTitle],
    [sheetDescription],
    ...periodNameRow,
    [],
    ...wrap(additionalMetadataRows || []),
  ];

  return grid;
};

export default metadataBuilder;
